const icon = `
  <svg class="main-ideas-svg" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 10H3V12H0V10ZM18.1 2.5L16 4.6L17.4 6L19.5 3.9L18.1 2.5ZM10 0H12V3H10V0ZM3.9 2.5L2.5 3.9L4.6 6L6 4.6L3.9 2.5ZM9 21C9 21.6 9.4 22 10 22H12C12.6 22 13 21.6 13 21V20H9V21ZM11 5C7.7 5 5 7.7 5 11C5 13.2 6.2 15.2 8 16.2V18C8 18.6 8.4 19 9 19H13C13.6 19 14 18.6 14 18V16.2C15.8 15.2 17 13.2 17 11C17 7.7 14.3 5 11 5ZM12 14.9V16H10V14.9C8.3 14.5 7 12.9 7 11C7 8.8 8.8 7 11 7C13.2 7 15 8.8 15 11C15 12.9 13.7 14.4 12 14.9ZM19 10H22V12H19V10Z" fill="#3C3C3C"/>
  </svg>
`;

export default icon;
